import Form from '../modules/form';
import { easepick } from '@easepick/bundle';

const Contacts = {
  init() {
    new Form('#contact-form');

    this.events();
  },

  events() {
    $('.department-select').on('change', function (e) {
      const department = $(this).data('department')
      Contacts.selectPerson(department);
    })

    const picker = new easepick.create({
      element: "#datepicker",
      css: [
        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css"
      ],
      zIndex: 10,
      format: "DD MMM YYYY",
      calendars: 2,
      grid: 2,
      readonly: false,
      plugins: [
        "RangePlugin"
      ]
    })

  },

  selectPerson(department) {
    Contacts.displayFields(department)
    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: 'JSON',
      data: {
        department: department,
        action: 'get_department_person'
      },
    })
      .done((response) => {
        if (response.success) {
          $('.contact-person').html(response.data);
        }
      })
      .always(() => {

      });
  },

  displayFields(department) {
    const additionalFields = $('.additional-fields')
    switch (department) {
      case 'business-travel':
      case 'general-inquiry':
        additionalFields.removeClass('show-additional')
        additionalFields.find('input').removeClass('required')
        additionalFields.find('input').val('')
        break;
      case 'inbound-tours':
      case 'meetings-events':
        additionalFields.addClass('show-additional')
        additionalFields.find('input').addClass('required')
        break;
      default:
        break;
    }
  }
};

export default Contacts;
